import { useAppDispatch, useAppSelector } from "redux/store";
import { fetchSession, showErrorModal } from "redux/slices";
import { selectAuthApi } from "redux/selectors";
import { useCallback, useEffect } from "react";

export function useLogin(actionAfterError?: () => void) {
  const dispatch = useAppDispatch();
  const { apiStatus, session, errorResponse } = useAppSelector(selectAuthApi);

  const login = useCallback(
    (guid: string) => {
      dispatch(fetchSession(guid));
    },
    [dispatch]
  );

  useEffect(() => {
    if (errorResponse) {
      dispatch(
        showErrorModal({
          text:
            errorResponse.Code === 10030
              ? "Il nome dell'account inserito non è corretto, non esiste nessuna area di transito associata al nome inserito."
              : errorResponse.Description,
        })
      );
      actionAfterError?.();
    }
  }, [actionAfterError, dispatch, errorResponse]);

  return {
    login,
    apiStatus,
    session,
    errorResponse,
  };
}
